import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import {isLoggedIn} from "../auth/index"

const Private = () => {
  return <Outlet />
 // return isLoggedIn()? <Outlet />:<Navigate to={'/login'} />
}

export default Private